import { TimerMinusOutlineIcon } from './TimerMinusOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 4F6F9FA4-0D4F-4543-95D4-9FF0AA8678BE
 * name timer-minus-outline
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-minus-outline.svg
 * tags
 * - Date / Time 
 */
export const TimerSubtractOutlineIcon = TimerMinusOutlineIcon;
export default TimerSubtractOutlineIcon